import React from "react";
// import free from "../img/freelancer.jpg";

const FreeLanser = () => {
  return (
    <section id="freelancer">
      <div className="row freebackImg">
        <div className="col-md-9 col-sm-12 freebackImg2">
          <h3>I am a freelancer</h3>
          <h1> Let’s work together</h1>
          <h3>
            If you need to build and design a beautiful website, our team of UI
            designers, front-end developers, and back-end developers can work
            with you to bring your vision to life. We collaborate with you from
            start to finish to ensure that your goals are met and your users are
            satisfied.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default FreeLanser;
